"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClearCroupierAction = void 0;
const logic_types_1 = require("../logic-types");
class ClearCroupierAction {
    constructor(board) {
        this.board = board;
    }
    execute() {
        if (!this.board.croupier.hasCards) {
            throw new Error("No croupier cards to clear");
        }
        const originPile = this.board.getPileByPileId(logic_types_1.PileId.Croupier);
        const targetPile = this.board.getPileByPileId(logic_types_1.PileId.Waste);
        this.cards = this.board.croupier.allCards.map((card) => card.clone());
        this.cards.forEach((card) => {
            targetPile.addCard(card);
        });
        originPile.removeAllCards();
    }
    resolve() {
        // Nothing
    }
    static isAction(action) {
        return action instanceof ClearCroupierAction;
    }
}
exports.ClearCroupierAction = ClearCroupierAction;
